import React from 'react';
import PropTypes from 'prop-types';
import { LinearProgress, withStyles } from '@material-ui/core';

import { Flex, Text } from 'Components/Base';

const styles = (theme) => ({
  colorPrimary: {
    backgroundColor: theme.palette.grey[300],
  },
  barColorPrimary: {
    backgroundColor: theme.palette.error.main,
  },
});

function LinearProgressWithLabel({ classes, value }) {
  return (
    <Flex alignItems="center" flexGrow={1} style={{ gap: '16px' }}>
      <LinearProgress
        classes={{ colorPrimary: classes.colorPrimary, barColorPrimary: classes.barColorPrimary }}
        value={value}
        variant="determinate"
        style={{ width: '100%' }}
      />
      <Text fontWeight={'normal'} textStyle={'caption'}>{`${Math.round(value)}%`}</Text>
    </Flex>
  );
}

LinearProgressWithLabel.propTypes = {
  value: PropTypes.number.isRequired,
};

export default withStyles(styles)(LinearProgressWithLabel);
